import React from 'react';
import SvgIcon from './SvgIcon';

const ListFull = props => (
    <SvgIcon viewBox="0 0 26 24" {...props}>
        <path
            d="M1 .75h24v4.5H1V.75zM1 18.75h24v4.5H1v-4.5zM1 9.745h24v4.5H1v-4.5z"
            stroke="currentColor"
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
);

ListFull.displayName = 'ListFullIcon';

export default ListFull;
